module.exports = __webpack_public_path__ + "assets/img/news (11).47aaa9fe.png";